export var USER = "User";
export var ROLE = "Role";
export var SUPPORT_PARTNER = "Support Partner";
export var STATUS = "Status";
export var LAST_LOGIN = "Last login ET";
export var EMAIL = "Email";
export var PHONE = "Phone";
export var USERS_TIME_ZONE = "User's time zone";
export var INACTIVATE_USER = "Inactivate user";
export var REACTIVATE_USER = "Reactivate user";
export var UNLOCK_USER = "Unlock user";
export var NAME = "Name";
export var FIRST_NAME = "First name";
export var LAST_NAME = "Last name";
export var MOBILE_PHONE = "Mobile phone";
export var COUNTRY_CODE = "Country code";
export var CUSTOM_PERMISSION = "Custom permission";
export var EDIT = "Edit";
export var REGISTER = "Register";
export var FILE_UPLOAD_INFO = "Upload a SVG, PNG, or JPG image with similar height and width that is less than 5MB";
export var HOURS = "hours";
export var HOURS_ABBREVIATION = "hrs";
export var MINUTES = "minutes";
export var MINUTES_ABBREVIATION = "mins";
export var DAYS = "days";
export var USERNAME = "Username";
export var PASSWORD = "Password";
export var CONFIRM_PASSWORD = "Confirm password";
export var CONFIRM_EMAIL = "Confirm email";
export var ACCOUNT_CREATED = "Account created";
export var LAST_MODIFIED = "Last modified";
export var WORK_PHONE = "Work phone";
export var CHANGE_PASSWORD = "Change password";
export var AUTOCLOSE_SR_FIELD = "autoCloseValue";
export var SESSION_TIMEOUT_FIELD = "sessionTimeoutValue";
export var CANCEL = "Cancel";
export var SUBMIT = "Submit";
export var INCONSISTENT_PASSWORD = "Passwords do not match.";
export var INCONSISTENT_EMAIL = "Emails do not match.";
export var PASSWORD_EXPIRY_DAYS = "passwordExpiryDays";
export var PASSWORD_EXPIRY_NOTF_DAYS = "passwordExpiryNotification";
export var USER_DEACTIVATION_DAYS = "userDeactivationDays";
export var AUTO_RESOLVE_PENDING_CUSTOMER = "autoResolveValue";
export var EXTENSION = "Extension";
export var FORMAT_UNSUPPORTED_ERR = "File format not supported.";
export var FILE_UPLOAD_SUCCESS = "File uploaded successfully.";
export var FILE_UPLOAD_FAILED = "File could not be uploaded.";
export var FILE_REMOVAL_SUCCESS = "File removed successfully.";
export var FILE_REMOVAL_FAILURE = "File could not be removed.";
export var MESSAGE = "Message";
export var TRANSACTIONS = "Transactions";
export var BALANCE = "Balance";
export var PRODUCT_CONFIG_TOOL = "Product configuration tool";
export var PRODUCT_CONFIG = "Product configuration";
export var ANALYTICS = "Analytics";
export var NEW_SITE_REQUEST = "New site request";
export var CREDIT_ACCELERATOR_FILE_JSON_PDF = "Credit Accelerator PDF, JSON";
export var CREDIT_ACCELERATOR = "Credit Accelerator";
export var TRIALS = "Trials";
export var PDF_JSON = "PDF, JSON";
export var PRODUCT_INSIGHTS_TOOL = "Product insights configuration tool";
export var PRODUCT_INSIGHTS_CONFIG = "Product insights configuration";
export var SR_ROUTING = "SR routing";
export var SUPPORT_USER = "MyYodlee User";
export var NORMAL_USER = "Insights User";
export var ACTIONS = "Actions";
export var USERNAMES = "User Names";
export var VALID_UNTIL = "Valid Until";
//# sourceMappingURL=label.js.map